module.exports = __webpack_public_path__ + "static/media/rating.9b2e0187.svg";